module.exports = __webpack_public_path__ + "static/comp-34954a159c769ce4059012a5b2fbd471.png";